import React from 'react';
import { createSvgIcon } from '../utils/createSvgIcon';

export const WarningCircle = createSvgIcon(
  () => (
    <path d="M17.7188 9.25C17.7188 4.46875 13.7812 0.53125 9 0.53125C4.18359 0.53125 0.28125 4.46875 0.28125 9.25C0.28125 14.0664 4.18359 17.9688 9 17.9688C13.7812 17.9688 17.7188 14.0664 17.7188 9.25ZM9 11.0078C9.87891 11.0078 10.6172 11.7461 10.6172 12.625C10.6172 13.5391 9.87891 14.2422 9 14.2422C8.08594 14.2422 7.38281 13.5391 7.38281 12.625C7.38281 11.7461 8.08594 11.0078 9 11.0078ZM7.45312 5.20703C7.41797 4.96094 7.62891 4.75 7.875 4.75H10.0898C10.3359 4.75 10.5469 4.96094 10.5117 5.20703L10.2656 9.98828C10.2305 10.2344 10.0547 10.375 9.84375 10.375H8.12109C7.91016 10.375 7.73438 10.2344 7.69922 9.98828L7.45312 5.20703Z" />
  ),
  '0 0 18 18'
);
